import { constants, mediaQueryStyles } from "@newsela/angelou";

import { PROGRESS_BAR_TYPES } from "@/challenges/constants/progressBarVersions.constants";
import fontStyleBuilder from "@/challenges/utils/fontStyleBuilder";

const { ui } = constants.colors;

const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { sm, xs },
} = constants.breakpoints;

const coreBlue500 = ui.core[500];
const neutral600 = ui.neutral[600];
const white500 = ui.white[500];
const neutral500 = ui.neutral[500];

const calcPercent = (achievedTokens, totalTokens) => {
  if (totalTokens > 0 && achievedTokens <= totalTokens)
    return `${(achievedTokens / totalTokens) * 100}%`;
  else if (totalTokens > 0 && achievedTokens >= totalTokens) return "100%";
  return "0%";
};

const cardVersionList = {
  [PROGRESS_BAR_TYPES.BADGE_CARD_VERSION]: {
    barHeight: "16px",
    progressBarContainerWidth: "85%",
    progressBarContainerMargin: "16px 0 0px 0",
    progressBarTitleSize: "14px",
    progressBarTitleWeight: "400",
  },
  [PROGRESS_BAR_TYPES.DETAILS_CARD_VERSION]: {
    barHeight: "24px",
    progressBarContainerWidth: "100%",
    progressBarContainerMargin: "16px 0 0px 0",
    progressBarTitleSize: "14px",
    progressBarTitleWeight: "400",
  },
  [PROGRESS_BAR_TYPES.HEADER_VERSION]: {
    barHeight: "24px",
    progressBarContainerWidth: "100%",
    progressBarContainerMargin: "0",
    progressBarTitleSize: "16px",
    progressBarTitleWeight: "700",
  },
  [PROGRESS_BAR_TYPES.TOPIC_CARD_VERSION]: {
    barHeight: "16px",
    progressBarContainerWidth: "85%",
    progressBarContainerMargin: "16px",
    progressBarTitleSize: "14px",
    progressBarTitleWeight: "400",
  },
  [PROGRESS_BAR_TYPES.REWARDS_CARD_VERSION]: {
    barHeight: "16px",
    progressBarContainerWidth: "100%",
    progressBarContainerMargin: "16px 0 16px 0",
    progressBarTitleSize: "14px",
    progressBarTitleWeight: "400",
  },
};

export const finalScoresCss = (bigSize) => ({
  color: neutral600,
  ...fontStyleBuilder({
    fontSize: bigSize ? "26px" : "16px",
    fontWeight: "700",
    lineHeight: "100%",
  }),
});

export const lableStyle = (bigSize, bold) => ({
  fontSize: bigSize ? "26px" : "14px",
  fontWeight: bold ? "700" : "400",
  margin: 0,
  fontFamily: "Circular",

  [mq.downTo(sm)]: {
    fontSize: bigSize ? "26px" : "16px",
  },
});

export const progressBarContainerCss = (cardVersion) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  width: cardVersionList[cardVersion].progressBarContainerWidth,
  margin: cardVersionList[cardVersion].progressBarContainerMargin,

  h5: {
    margin: "0",
    color: neutral600,
    ...fontStyleBuilder({
      fontSize: cardVersionList[cardVersion].progressBarTitleSize,
      fontWeight: cardVersionList[cardVersion].progressBarTitleWeight,
      lineHeight: "175%",
    }),
  },
});

export const progressBarContentCss = (cardVersion, bigSize) => ({
  width: "100%",
  height: bigSize ? "48px" : cardVersionList[cardVersion].barHeight,
  border: `1px solid ${neutral500}`,
  borderRadius: "54px",
  backgroundColor: white500,
  padding: "4px",

  [mq.upTo(xs)]: {
    height: bigSize ? "24px" : cardVersionList[cardVersion].barHeight,
  },
});

export const progressBarHeaderCss = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  marginBottom: "4px",
};

export const progressBarTitleCss = {
  display: "flex",
  alignItems: "center",
  justifyContent: "start",
  gap: "4px",
  width: "100%",
};

export const progressPercentageCss = (achievedTokens, totalTokens) => ({
  width: calcPercent(achievedTokens, totalTokens),
  height: "100%",
  borderRadius: "56px",
  borderTopRightRadius:
    calcPercent(achievedTokens, totalTokens) === "100%" ? "56px" : "0",
  borderBottomRightRadius:
    calcPercent(achievedTokens, totalTokens) === "100%" ? "56px" : "0",
  backgroundColor: coreBlue500,
});

export const progressPointsCounter = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  marginTop: "4px",
  width: "100%",
};

export const rewardIconCss = {
  width: "23px",
  height: "23px",
};

export const articleIconCss = {
  width: "31.998px",
  height: "31.998px",
};
